import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M8.88 4.6c-.8-3.46-6.01-3.47-6.81 0-.47 2.03.82 3.75 1.94 4.82.82.77 2.11.77 2.93 0 1.12-1.07 2.4-2.79 1.94-4.82M5.51 6.2c-.55 0-1-.45-1-1s.44-1 .99-1h.01c.56 0 1 .45 1 1s-.44 1-1 1",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M6.51 5.2c0 .55-.44 1-1 1-.55 0-1-.45-1-1s.44-1 .99-1h.01c.56 0 1 .45 1 1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M21.91 16.6c-.8-3.46-6.03-3.47-6.84 0-.47 2.03.82 3.75 1.95 4.82.82.77 2.12.77 2.94 0 1.13-1.07 2.42-2.79 1.95-4.82m-3.38 1.6c-.55 0-1-.45-1-1s.44-1 .99-1h.01c.55 0 1 .45 1 1s-.45 1-1 1",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M19.53 17.2c0 .55-.45 1-1 1s-1-.45-1-1 .44-1 .99-1h.01c.55 0 1 .45 1 1M12 19.75H9.32c-1.16 0-2.17-.7-2.57-1.78-.41-1.08-.11-2.27.76-3.04l7.99-6.99c.48-.42.49-.99.35-1.38-.15-.39-.53-.81-1.17-.81H12c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.68c1.16 0 2.17.7 2.57 1.78.41 1.08.11 2.27-.76 3.04L8.5 16.06c-.48.42-.49.99-.35 1.38.15.39.53.81 1.17.81H12c.41 0 .75.34.75.75s-.34.75-.75.75"
    }, null, -1)
  ]))]))
}
export default { render: render }